import { render, staticRenderFns } from "./Navigation.vue?vue&type=template&id=88c0336c&"
import script from "./Navigation.vue?vue&type=script&lang=js&"
export * from "./Navigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88c0336c')) {
      api.createRecord('88c0336c', component.options)
    } else {
      api.reload('88c0336c', component.options)
    }
    module.hot.accept("./Navigation.vue?vue&type=template&id=88c0336c&", function () {
      api.rerender('88c0336c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/library/Navigation.vue"
export default component.exports